<div class="text-center">
    <img src='/assets/2.png' class="onboarding-img" alt='image'>
    <div class="text-center ml-auto mr-auto w-50">
        <h1>Log on a Sleep Diary</h1>
        <p>
            Your sleep record helps us identify the sleep disruptions and other factors that affects your sleep quality.
        </p>
    </div>
    </div>